function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

const _ = require('lodash');

function _call(body, then, direct) {
  if (direct) {
    return then ? then(body()) : body();
  }

  try {
    var result = Promise.resolve(body());
    return then ? result.then(then) : result;
  } catch (e) {
    return Promise.reject(e);
  }
}

const Plan = require('../entities/plan');

function _empty() {}

function _invokeIgnored(body) {
  var result = body();

  if (result && result.then) {
    return result.then(_empty);
  }
}

function _invoke(body, then) {
  var result = body();

  if (result && result.then) {
    return result.then(then);
  }

  return then(result);
}

class PlanPipeline {
  constructor({
    context
  }) {
    this.context = context;
    this.localState = {};
    this.remoteState = {};
  }

  initialize() {
    const _this = this;

    return _call(function () {
      const {
        client,
        accessContext
      } = _this.context;
      const {
        propertyId
      } = accessContext.serialize();
      return _await(client.properties.for(propertyId).plans.getSettings(), function (defaultSettings) {
        _this.localState.plan = new Plan({
          settings: defaultSettings
        });
        return _this;
      });
    });
  }

  load(id) {
    const _this2 = this;

    return _call(function () {
      const {
        client,
        accessContext
      } = _this2.context;
      const {
        propertyId
      } = accessContext.serialize();
      return _await(client.properties.for(propertyId).plans.for(id).details(), function (plan) {
        _this2.localState.plan = plan.clone();
        _this2.remoteState.plan = plan.clone();
        return _this2;
      });
    });
  }

  save(fieldsToMerge) {
    const _this3 = this;

    return _call(function () {
      _this3.mergeLocalState(fieldsToMerge);

      const {
        client,
        accessContext
      } = _this3.context;
      const {
        propertyId
      } = accessContext.serialize();
      const plansRepo = client.properties.for(propertyId).plans;
      const localPlan = _this3.localState.plan;
      const remotePlan = _this3.remoteState.plan;
      const planId = remotePlan && remotePlan.id;
      let plan;
      return _await(_invoke(function () {
        if (planId) {
          const diff = remotePlan.diff(localPlan);
          return _invokeIgnored(function () {
            if (_.isEmpty(diff)) {
              // If there are no differences, don't make a request
              plan = localPlan;
            } else {
              return _await(plansRepo.for(planId).update(diff), function (_plansRepo$for$update) {
                plan = _plansRepo$for$update;
              });
            }
          });
        } else {
          return _await(plansRepo.create(localPlan), function (_plansRepo$create) {
            plan = _plansRepo$create;
          });
        }
      }, function () {
        _this3.remoteState.plan = plan.clone();
        return _this3;
      }));
    });
  }

  mergeLocalState(fieldsToMerge = {}) {
    // TODO: Determine generic merge strategy
    this.localState.plan = _.merge(this.localState.plan, fieldsToMerge.plan);
  }

  getLocalState() {
    return this.localState;
  }

  setLocalState(state) {
    this.localState = state;
  }

  getRemoteState() {
    return this.remoteState;
  }

}

module.exports = PlanPipeline;